/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enum of actions that are possible across the admin zone.
 */
export const PlatformActionType = {
    PlatformUserManagement: 1,
    CaseManagement: 2,
    CaseRoleManagement: 3,
    ClaimManagement: 4,
    ContractManagement: 5,
    ClientManagement: 6,
    Mailing: 7,
    EvidenceManagement: 8
} as const;
export type PlatformActionType = typeof PlatformActionType[keyof typeof PlatformActionType];

